import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export default function Categories() {
    const [cats, setCats] = useState([]);
    useEffect(() => {
        api.get("/categories").then((r) => setCats(r.data));
    }, []);

    return (
        <div
            className="max-w-[1440px] mx-auto px-6 md:px-12 pt-16 pb-32"
            data-testid="categories-page"
        >
            <div className="overline mb-4">The Atelier</div>
            <h1
                className="font-serif text-5xl sm:text-6xl tracking-tight mb-12"
                style={{ color: "var(--vl-text)" }}
                data-testid="categories-title"
            >
                Every{" "}
                <em
                    style={{
                        color: "var(--vl-rose)",
                        fontStyle: "italic",
                    }}
                >
                    collection.
                </em>
            </h1>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                {cats.map((c) => (
                    <Link
                        key={c.slug}
                        to={`/shop?category=${c.slug}`}
                        className="relative overflow-hidden block"
                        data-testid={`category-${c.slug}`}
                        style={{
                            background: "var(--vl-surface)",
                            aspectRatio: "4 / 5",
                        }}
                    >
                        <img
                            src={c.image}
                            alt={c.name}
                            className="vl-img absolute inset-0 w-full h-full object-cover"
                            style={{ filter: "brightness(0.75)" }}
                        />
                        <div
                            className="absolute inset-0"
                            style={{
                                background:
                                    "linear-gradient(180deg, rgba(0,0,0,0) 30%, rgba(0,0,0,0.8) 100%)",
                            }}
                        />
                        <div className="absolute inset-0 flex flex-col justify-end p-7">
                            <div
                                className="overline mb-3"
                                style={{ color: "var(--vl-beige)" }}
                            >
                                {c.tagline}
                            </div>
                            <div
                                className="font-serif text-3xl tracking-tight"
                                style={{ color: "var(--vl-text)" }}
                            >
                                {c.name}
                            </div>
                            <p
                                className="text-sm mt-3 max-w-xs"
                                style={{
                                    color: "var(--vl-muted)",
                                    lineHeight: 1.7,
                                }}
                            >
                                {c.description}
                            </p>
                            <span
                                className="overline mt-6"
                                style={{ color: "var(--vl-rose)" }}
                            >
                                Explore →
                            </span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
